<template>
  <b-card no-body class="card-accent-primary">
    <b-card-header class="p-0">
      <b-row>
        <b-col>
          <p class="mx-3 my-2">
            Resultados de Búsqueda:
            <b>{{ tableName }}</b>
          </p>
        </b-col>
        <b-col class="text-right">
          <b-button :disabled="!data.length" class="m-1" variant="success" size="sm" @click="exportReport">
            Exportar
          </b-button>
        </b-col>
      </b-row>
    </b-card-header>
    <b-table
      class="cartera-table m-0"
      head-variant="light"
      small
      hover
      striped
      responsive
      :items="data"
      :fields="columns"
      :busy="loading"
      :per-page="0"
      :current-page="currentPage"
      @sort-changed="setSortParam"
      @row-clicked="verTomador"
    >
      <div slot="table-busy" class="text-center text-info my-2">
        <b-spinner class="align-middle mx-2"></b-spinner>
        <strong>Obteniendo resultados...</strong>
      </div>
      <div slot="fec_retencion" slot-scope="data">{{ data.item.fec_retencion | date }}</div>
      <div slot="nro_certificado" slot-scope="data" class="text-center">{{ data.item.nro_certificado }}</div>
      <div slot="impuesto" slot-scope="data">{{ data.item.impuesto }}</div>
      <div slot="cod_agente" slot-scope="data">{{ data.item.cod_agente }}</div>
      <div slot="nombre_agente" slot-scope="data">{{ data.item.nombre_agente }}</div>
      <div slot="base" slot-scope="data" class="text-right">{{ data.item.base | numberFormat }}</div>
      <div slot="pje_retencion" slot-scope="data" class="text-right">{{ data.item.pje_retencion }}</div>
      <div slot="retencion" slot-scope="data" class="text-right">{{ data.item.retencion | numberFormat }}</div>
    </b-table>
    <b-card-footer class="px-3 py-2">
      <b-row align-v="center">
        <b-col v-if="!loading">{{ perPage * (currentPage-1) + data.length }} de {{ records }} resultados</b-col>
        <b-col v-if="!loading">
          <b-pagination
            size="sm"
            :total-rows="records"
            :per-page="perPage"
            v-model="currentPage"
            prev-text="Anterior"
            next-text="Siguiente"
            @change="setCurrentPage"
          />
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>


<script>
import moment from 'moment';
import { numberFormat } from '@/helpers/filters'

export default {
  props: {
    records: {
      type: String | Number
    },
    data: {
      type: Array
    },
    loading: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      required: true
    },
    tableName: {
      type: String
    },
    perPage: {
      type: String | Number
    },
    clickable: {
      type: Boolean,
      default: false
    },
    clientSideTreat: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: 1
    };
  },
  methods: {
    setCurrentPage: function(n) {
      const filter = {
        start: n,
        length: 10
      };
      this.currentPage = n;
      this.$emit('pageChange', n - 1);
      /*if (!this.clientSideTreat) {
        this.$emit('pageChange', n - 1);
      }*/
    },
    setSortFilter(sortParams) {
      this.currentPage = 1;
      const filter = {
        start: 0,
        length: 10,
        order: sortParams.order,
        direction: sortParams.direction
      };
      this.getPolizas(filter);
    },
    exportReport() {
      this.$emit('exportReport');
    },
    setSortParam(ctx) {
      const sortParams = {};
      sortParams.direction = ctx.sortDesc ? 'desc' : 'asc';
      sortParams.order = ctx.sortBy;
      this.$emit('sorted', sortParams);
    },
    verTomador(row) {
      if (this.clickable) {
        if (row.cod_ramo == 26){
          this.$toast.warning('Abrir desde AUTOS', 'Atencion:')
          return;
        }else 
          this.$router.push('/tomador/' + row.id_tomador + '/' + row.asegurado + '/' + row.nro_pol + '/' + row.cod_agente);
      }
    }
  },
  filters: {
    numberFormat: numberFormat,

    dateInv(di) {
      return moment(di, 'YYYY-DD-MM').format('DD/MM/YY')
    }
  },
  computed: {
    rowsPerPage() {
      if (this.data) {
        return this.data.length >= this.perPage ? this.perPage : this.data.length;
      }
    }
  }
};
</script>
